export default "__VITE_ASSET__KyOd8kqQ__"